module.exports = __webpack_public_path__ + "img/8.e9854943.jpg";